// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SQyZ","toggleWrap":"styles_toggleWrap__3BfCB","content":"styles_content__K8DXp","selectAreaCode":"styles_selectAreaCode__3ICnX"};